import {FC} from 'react';
import {IonInput, IonItem, IonLabel} from '@ionic/react';
import {closeCircleOutline} from 'ionicons/icons';
import UIIcon from './UIIcon';

type UIStackedInputProps = {
  text?: string;
  setText?: Function;
  labelText?: string;
  placeholder?: string;
  style?: string;
  textStyle?: string;
  type?: 'email' | 'text' | 'password';
  hideLabelOnMobile?: boolean;
  maxLength?: number;
  name?: string;
  onChange?: Function;
  onKeyPress?: Function;
  onFocus?: Function;
  badInput?: string;
  autoComplete?: any;
  inputMode?: any;
}

const UIStackedInput: FC<UIStackedInputProps> = ({
  text,
  setText,
  labelText,
  placeholder,
  style='rounded-15',
  textStyle,
  type = 'text',
  hideLabelOnMobile,
  maxLength,
  name,
  onChange,
  onKeyPress,
  onFocus,
  badInput,
  autoComplete = 'off',
  inputMode,
}) => {
  if (text === null) {
    return null;
  }
  return (
    <IonItem
      className={`${textStyle ? textStyle : 'font-semibold'} ${hideLabelOnMobile && 'md:mb-2'}
      text-navy-black transparent-bg leading-7 no-padding text-sm font-Manrope`} lines='none'>
      <div className='w-full'>
        <div className={` ${hideLabelOnMobile && 'h-5 md:h-auto'}`}>
          <div className={`${hideLabelOnMobile && 'hidden md:block'} `}>
            {labelText && (<IonLabel className='w-full'>{labelText}</IonLabel>)}
          </div>
        </div>
        <div className='w-full relative'>
          <IonInput
            onKeyPress={(e) => onKeyPress && onKeyPress(e)}
            onIonFocus={(e) => onFocus && onFocus(e)}
            maxlength={maxLength}
            type={type}
            name={name}
            inputMode={inputMode}
            value={text}
            clearOnEdit={badInput !== undefined}
            placeholder={placeholder}
            autocomplete={autoComplete}
            onIonChange={(e) => (setText && setText(e.detail.value)) || (onChange && onChange(e))}
            className={`relative bg-white md:bg-white md:text-navy-black md:caret-black-ink
           md:rounded-md h-16 md:h-11 ${style}
            ${badInput ? 'border-2 border-red-form' : 'border md:border-neutral-200 border-neutral-500'}`}
          />
          {badInput && <UIIcon style='text-red-form mr-5 text-3xl absolute right-0 top-4 md:top-2 z-40'
            icon={closeCircleOutline}/>}
          <span className='text-red-form text-xs font-Manrope font-semibold'>{badInput}</span>
        </div>
      </div>
    </IonItem>
  );
};

export default UIStackedInput;
